import globals from "imports/globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    gsap.registerPlugin(ScrollTrigger);

    $(document).ready(function () {
        function isNavLink(_el) {
            return $(_el).parents("#nav").length;
        }

        function menuOpenHandler() {
            $("html").addClass("menu-visible overlay-visible");
        }

        function menuCloseHandler() {
            $("html").removeClass("menu-visible overlay-visible");
        }

        $(".burger").on("click", function () {
            if ($("html").hasClass("menu-visible")) {
                menuCloseHandler();
            } else {
                menuOpenHandler();
            }
        });

        $("body").on("keyup", "a, button, input", function (e) {
            if (e.which == 9) {
                if (isNavLink(e.target)) {
                    menuOpenHandler();
                } else {
                    menuCloseHandler();
                }
            }
        });

        $("#nav a").on("click", function (e) {
            if ($(e.target).hasClass("site-tagline")) {
                e.preventDefault();
                window.scrollTo(0, 0);
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
            menuCloseHandler();
        });

        ScrollTrigger.create({
            trigger: $(".chapters")[0],
            start: `top top`,
            end: `bottom top`,
            onToggle: function (_self) {
                if (_self.isActive) {
                    $(".navbar").toggleClass("on");
                } else {
                    $(".navbar").toggleClass("on");
                }
            },
            // markers: true,
        });
    });
})();

export default component;
